// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%275%27 viewBox=%270 0 8 4%27%3E%3Cpath d=%27M4 4L0.535899 0.25L7.4641 0.25L4 4Z%27 fill=%27%23102C98%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientCandidateReport {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
}
.ClientCandidateReport .Table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}
.ClientCandidateReport .Table .TableContainer {
  display: flex;
  width: 100%;
  min-height: 20%;
  padding-bottom: 0.3rem;
  overflow: auto;
}
.ClientCandidateReport .Table .TableContainer > * {
  flex: 1 1;
}
.ClientCandidateReport .Table .TableContainer ::-webkit-scrollbar {
  width: 0.3rem;
  height: 0.3rem;
  background-color: var(--Foreground);
}
.ClientCandidateReport .Table .TableContainer ::-webkit-scrollbar-thumb {
  background-color: var(--AccentColor);
  border-radius: 10px;
}
.ClientCandidateReport .Table .TableContainer ::-webkit-scrollbar-track {
  background-color: var(--Foreground);
  border-radius: 10px;
}
.ClientCandidateReport .Table .TableContainer ::-webkit-scrollbar-corner {
  background-color: var(--Foreground);
}
.ClientCandidateReport .Table .TableContainer table {
  width: 100%;
  border-collapse: separate;
}
.ClientCandidateReport .Table .TableContainer table thead {
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2);
  position: sticky;
  top: 0;
  z-index: 9;
}
.ClientCandidateReport .Table .TableContainer table thead tr th {
  padding-top: 0rem 1.5rem;
}
.ClientCandidateReport .Table .TableContainer table tbody tr td.fixed-column {
  width: 9.3rem;
  z-index: 1;
  position: sticky;
  right: 0;
}
.ClientCandidateReport .Table .TableContainer table tbody tr td.fixed-column:hover {
  background-color: var(--Hover);
}
.ClientCandidateReport .Table .TableContainer table tbody tr:hover {
  background-color: var(--Hover);
}
.ClientCandidateReport .Table .TableContainer table th,
.ClientCandidateReport .Table .TableContainer table td {
  font-size: 0.8rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--TextColor);
  background-color: var(--Foreground);
}
.ClientCandidateReport .Table .TableContainer table .status {
  border-radius: 1.25rem;
  padding: 0.4rem 0.9rem;
  text-align: center;
  text-transform: capitalize;
  min-width: 8rem;
}
.ClientCandidateReport .Table .TableContainer table .completed {
  background-color: var(--Completed);
}
.ClientCandidateReport .Table .TableContainer table .pending {
  background-color: var(--Pending);
}
.ClientCandidateReport .Table .TableContainer table .inprogress {
  background-color: var(--Inprogress);
}
.ClientCandidateReport .Table .TableContainer table .accepted {
  background-color: var(--Accepted);
}
.ClientCandidateReport .Table .TableContainer table .re-initiated {
  background-color: var(--Reinitiated);
}
.ClientCandidateReport .Table .TableContainer table .cancelled {
  background-color: var(--Cancelled);
}
.ClientCandidateReport .Table .TableContainer table .invitation {
  background-color: var(--Invitation);
}
.ClientCandidateReport .Table .TableContainer table .fixed-column {
  width: 9.3rem;
  position: sticky;
  right: 0;
  z-index: 1;
  background-color: var(--Foreground);
  padding: 0.6rem 0.9rem;
}
.ClientCandidateReport .Table .TableContainer table .fixed-column div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ClientCandidateReport .Table .TableContainer table .fixed-column div p {
  color: var(--TextColor);
}
.ClientCandidateReport .Table .TableContainer table .fixed-column div svg {
  cursor: pointer;
}
.ClientCandidateReport .Table .TableContainer .Actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  z-index: 1;
}
.ClientCandidateReport .Table .TableContainer .Actions svg {
  cursor: pointer;
}
.ClientCandidateReport .Table .TableContainer .Actions svg path {
  fill: var(--TextColor);
}
.ClientCandidateReport .Table .TableContainer .Actions .Update {
  font-size: 0.75rem;
  color: var(--AccentColor);
  cursor: pointer;
}
.ClientCandidateReport .Table .PaginationContainer {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2.5rem;
  padding-right: 10px;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 130px);
  height: 100%;
  gap: 10px;
  padding-left: 1.25rem;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination .NextPrev {
  color: #363854;
  background: none;
  border: none;
  font-weight: 700;
  padding: 5px 10px;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination .NextPrev:hover {
  border-radius: 25px;
  background: #efefef;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination .PageNo {
  width: 25px;
  height: 25px;
  color: #363854;
  border-radius: 1.25rem;
  padding: 5px;
  background: none;
  border: none;
  font-weight: 700;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination .PageNo:hover {
  background: #efefef;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination .CurrentPage {
  background: #efefef;
}
.ClientCandidateReport .Table .PaginationContainer .Pagination .disabled {
  color: #8a8a8a;
  cursor: not-allowed;
}
.ClientCandidateReport .Table .PaginationContainer .ItemsPerPage {
  width: 122px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #102c98;
  border-radius: 0.5rem;
  padding-right: 5px;
}
.ClientCandidateReport .Table .PaginationContainer .ItemsPerPage .OptionsLabel {
  color: #363854;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0px 16px;
  border-right: 1px solid #102c98;
}
.ClientCandidateReport .Table .PaginationContainer .ItemsPerPage .Options {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right center;
  background-size: 0.875rem;
  width: 55px;
  height: 1.25rem;
  border: none;
  font-size: 0.75rem;
  color: #363854;
  outline: none;
}
.ClientCandidateReport .Table .PaginationContainer .ItemsPerPage .Options option {
  background-color: #fff;
  color: #363854;
  text-align: center;
}
.ClientCandidateReport .LoaderContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/ClientComponents/ClientCandidateReport.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAEJ;AADI;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AAGN;AAFM;EACE,SAAA;AAIR;AAFM;EACE,aAAA;EACA,cAAA;EACA,mCAAA;AAIR;AAFM;EACE,oCAAA;EACA,mBAAA;AAIR;AAFM;EACE,mCAAA;EACA,mBAAA;AAIR;AAFM;EACE,mCAAA;AAIR;AAFM;EACE,WAAA;EACA,yBAAA;AAIR;AAHQ;EACE,wCAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAKV;AAFY;EACE,wBAAA;AAId;AAGY;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;AADd;AAEc;EACE,8BAAA;AAAhB;AAGY;EACE,8BAAA;AADd;AAMQ;;EAEE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;AAJV;AAOQ;EACE,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AALV;AAQQ;EACE,kCAAA;AANV;AAQQ;EACE,gCAAA;AANV;AAQQ;EACE,mCAAA;AANV;AAQQ;EACE,iCAAA;AANV;AAQQ;EACE,oCAAA;AANV;AAQQ;EACE,kCAAA;AANV;AAQQ;EACE,mCAAA;AANV;AASQ;EACE,aAAA;EACA,gBAAA;EACA,QAAA;EACA,UAAA;EACA,mCAAA;EACA,sBAAA;AAPV;AASU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAPZ;AASY;EACE,uBAAA;AAPd;AASY;EACE,eAAA;AAPd;AAYM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;AAVR;AAWQ;EACE,eAAA;AATV;AAUU;EACE,sBAAA;AARZ;AAWQ;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;AATV;AAaI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAXN;AAYM;EACE,aAAA;EACA,mBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;AAXR;AAYQ;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAVV;AAYQ;EACE,mBAAA;EACA,mBAAA;AAVV;AAYQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAVV;AAYQ;EACE,mBAAA;AAVV;AAYQ;EACE,mBAAA;AAVV;AAYQ;EACE,cAAA;EACA,mBAAA;AAVV;AAaM;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAXR;AAYQ;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAVV;AAYQ;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0EAAA;EAEA,yBAAA;EACA,WAAA;EAEA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAZV;AAaU;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;AAXZ;AAiBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAfJ","sourcesContent":[".ClientCandidateReport {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  position: relative;\n  .Table {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: auto;\n    .TableContainer {\n      display: flex;\n      width: 100%;\n      min-height: 20%;\n      padding-bottom: 0.3rem;\n      overflow: auto;\n      & > * {\n        flex: 1;\n      }\n      ::-webkit-scrollbar {\n        width: 0.3rem;\n        height: 0.3rem;\n        background-color: var(--Foreground);\n      }\n      ::-webkit-scrollbar-thumb {\n        background-color: var(--AccentColor);\n        border-radius: 10px;\n      }\n      ::-webkit-scrollbar-track {\n        background-color: var(--Foreground);\n        border-radius: 10px;\n      }\n      ::-webkit-scrollbar-corner {\n        background-color: var(--Foreground);\n      }\n      table {\n        width: 100%;\n        border-collapse: separate;\n        thead {\n          box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2);\n          position: sticky;\n          top: 0;\n          z-index: 9;\n\n          tr {\n            th {\n              padding-top: 0rem 1.5rem;\n            }\n          }\n        }\n\n        tbody {\n          tr {\n            td.fixed-column {\n              width: 9.3rem;\n              z-index: 1;\n              position: sticky;\n              right: 0;\n              &:hover {\n                background-color: var(--Hover);\n              }\n            }\n            &:hover {\n              background-color: var(--Hover);\n            }\n          }\n        }\n\n        th,\n        td {\n          font-size: 0.8rem;\n          text-align: left;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          color: var(--TextColor);\n          background-color: var(--Foreground);\n        }\n\n        .status {\n          border-radius: 1.25rem;\n          padding: 0.4rem 0.9rem;\n          text-align: center;\n          text-transform: capitalize;\n          min-width: 8rem;\n        }\n\n        .completed {\n          background-color: var(--Completed);\n        }\n        .pending {\n          background-color: var(--Pending);\n        }\n        .inprogress {\n          background-color: var(--Inprogress);\n        }\n        .accepted {\n          background-color: var(--Accepted);\n        }\n        .re-initiated {\n          background-color: var(--Reinitiated);\n        }\n        .cancelled {\n          background-color: var(--Cancelled);\n        }\n        .invitation {\n          background-color: var(--Invitation);\n        }\n\n        .fixed-column {\n          width: 9.3rem;\n          position: sticky;\n          right: 0;\n          z-index: 1;\n          background-color: var(--Foreground);\n          padding: 0.6rem 0.9rem;\n\n          div {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n\n            p {\n              color: var(--TextColor);\n            }\n            svg {\n              cursor: pointer;\n            }\n          }\n        }\n      }\n      .Actions {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 0.75rem;\n        z-index: 1;\n        svg {\n          cursor: pointer;\n          path {\n            fill: var(--TextColor);\n          }\n        }\n        .Update {\n          font-size: 0.75rem;\n          color: var(--AccentColor);\n          cursor: pointer;\n        }\n      }\n    }\n    .PaginationContainer {\n      height: 50px;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      gap: 2.5rem;\n      padding-right: 10px;\n      .Pagination {\n        display: flex;\n        flex-direction: row;\n        // justify-content: space-between;\n        align-items: center;\n        width: calc(100% - 130px);\n        height: 100%;\n        gap: 10px;\n        padding-left: 1.25rem;\n        .NextPrev {\n          color: #363854;\n          background: none;\n          border: none;\n          font-weight: 700;\n          padding: 5px 10px;\n        }\n        .NextPrev:hover {\n          border-radius: 25px;\n          background: #efefef;\n        }\n        .PageNo {\n          width: 25px;\n          height: 25px;\n          color: #363854;\n          border-radius: 1.25rem;\n          padding: 5px;\n          background: none;\n          border: none;\n          font-weight: 700;\n        }\n        .PageNo:hover {\n          background: #efefef;\n        }\n        .CurrentPage {\n          background: #efefef;\n        }\n        .disabled {\n          color: #8a8a8a;\n          cursor: not-allowed;\n        }\n      }\n      .ItemsPerPage {\n        width: 122px;\n        height: 30px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        border: 1px solid #102c98;\n        border-radius: 0.5rem;\n        padding-right: 5px;\n        .OptionsLabel {\n          color: #363854;\n          font-size: 0.75rem;\n          font-weight: 500;\n          padding: 0px 16px;\n          border-right: 1px solid #102c98;\n        }\n        .Options {\n          appearance: none;\n          -webkit-appearance: none;\n          -moz-appearance: none;\n          background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='5' viewBox='0 0 8 4'%3E%3Cpath d='M4 4L0.535899 0.25L7.4641 0.25L4 4Z' fill='%23102C98'/%3E%3C/svg%3E\")\n            no-repeat right center;\n          background-size: 0.875rem;\n          width: 55px;\n          // padding-left: 10px;\n          height: 1.25rem;\n          border: none;\n          font-size: 0.75rem;\n          color: #363854;\n          outline: none;\n          option {\n            background-color: #fff;\n            color: #363854;\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n  .LoaderContainer {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2c2c2c50;\n    z-index: 3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
